module.exports = __webpack_public_path__ + "img/zp4.1d3edcdd.png";